import { gql } from '@apollo/client'

/* coinRates no longer exists in backend schema */
export const GET_COINS_RATES = gql`
  query coinRatesStub {
    __typename
  }
`
